<template>
  <v-dialog v-model="value" max-width="500px" persistent>
    <v-card class="pa-4" outlined>
      <div class="d-flex py-2">
        <v-spacer></v-spacer>
        <h3>Gerenciar acessos</h3>
        <v-spacer></v-spacer>
        <v-btn icon absolute top right @click="$emit('close')">
          <v-icon> mdi-close </v-icon>
        </v-btn>
      </div>
      <v-divider class="my-2"></v-divider>
      <v-row class="ma-0">
        <v-col cols="12">
          <v-card
            class="pa-4 d-flex flex-column"
            outlined
            rounded="lg"
            height="100%"
          >
            <div>
              <div class="d-flex justify-center">
                <v-avatar
                  size="40"
                  class="mr-2"
                  v-if="currentInstitution.logoPath"
                >
                  <v-img :src="currentInstitution.logoPath" contain></v-img>
                </v-avatar>
                <p v-else>
                  <v-icon size="30" color="grey darken-1">mdi-domain</v-icon>
                </p>
              </div>
              <p class="text-center" style="word-break: keep-all">
                <b>{{ currentInstitution.name }}</b>
              </p>
            </div>
            <v-spacer></v-spacer>
            <v-form ref="user-institution-form">
              <div>
                <label for="name">Tipo de Acesso</label>
                <v-select
                  v-model="user.userType"
                  :items="types"
                  item-text="text"
                  item-value="value"
                  placeholder="Selecione o tipo de acesso"
                  hide-details="auto"
                  height="45"
                  append-icon="mdi-chevron-down"
                  :disabled="loading"
                  outlined
                  background-color="#F5F5F5"
                  class="rounded-lg mb-2"
                ></v-select>
              </div>
              <div>
                <label for="name">Unidades</label>
                <v-select
                  v-model="user.unidades"
                  :items="unidades"
                  multiple
                  item-text="name"
                  item-value="id"
                  placeholder="Selecione a unidade"
                  hide-details="auto"
                  append-icon="mdi-chevron-down"
                  :disabled="loading"
                  outlined
                  background-color="#F5F5F5"
                  class="rounded-lg mb-2"
                >
                  <template
                    v-slot:selection="{ attrs, item, select, selected, index }"
                  >
                    <v-chip
                      v-if="index === 0"
                      v-bind="attrs"
                      :input-value="selected"
                      color="#BBCF20"
                      text-color="#fff"
                      small
                      @click="select"
                    >
                      {{ item.name }}
                    </v-chip>
                    <span
                      v-if="user.unidades && index === 1"
                      class="grey--text text-caption"
                      style="font-size: 0.8rem"
                    >
                      ( +{{ user.unidades.length - 1 }} )
                    </span>
                  </template>
                </v-select>
              </div>
            </v-form>
            <v-spacer></v-spacer>
          </v-card>
        </v-col>
      </v-row>
      <v-divider class="my-4"></v-divider>
      <div class="d-flex">
        <v-spacer></v-spacer>
        <v-btn
          class="ma-0 secondary-button"
          depressed
          :loading="loading"
          @click="submit"
        >
          Salvar
        </v-btn>
      </div>
    </v-card>
  </v-dialog>
</template>

<script>
import ApiService from '../../../../services/ApiService'

export default {
  name: 'UserInstitutionModal',
  props: {
    value: Boolean,
    userInstitutions: Array,
    types: Array,
    localUserId: {
      type: String,
      default: null,
    },
  },

  data() {
    return {
      unidades: [],
      apiService: new ApiService(),
      user: {
        unidades: [],
        userType: '',
      },
      currentInstitution: {},
      loading: false,
      currentInstitutionId: null,
      loggedUser: JSON.parse(localStorage.getItem('user')),
    }
  },

  created() {
    this.getUnidades()
    this.getInstitution()
  },

  methods: {
    submit() {
      this.apiService
        .post(`user/addAccess`, {
          userId: this.localUserId,
          institutionId: this.currentInstitutionId,
          userType: this.user.userType,
          unidades: this.user.unidades.map((id) => ({ unidadeId: id })),
        })
        .then((response) => {
          this.$toast.success('Acesso adicionado com sucesso!')
          this.$emit('closeall')
          this.$emit('updateUserInstitutions', response.content)
        })
        .catch((error) => {
          console.error(error)
        })
    },

    getUnidades() {
      this.currentInstitutionId = JSON.parse(
        localStorage.getItem('institution')
      ).id

      this.apiService
        .post('unidade/listByIntitutionIds', {
          ids: [this.currentInstitutionId],
        })
        .then((response) => {
          this.unidades = response.content
        })
        .catch(() => {})
    },

    getInstitution() {
      this.apiService
        .get(`institution/${this.currentInstitutionId}`)
        .then((response) => {
          this.currentInstitution = response.content
        })
    },
  },
}
</script>
